import Image from "next/image";
import { useRouter } from "next/router";
import Meta from "../../components/Meta";

const Single_post = () => {
  const router = useRouter();
  const pid = router.query.single_post; // This would typically be the ID of the blog post to fetch

  // For this example, we'll use a hardcoded data structure
  // In a real application, you'd fetch data based on `pid`
  const blogPostData = {
    id: "gamification-as-a-tool-for-impact",
    image: "/images/new/3.png", // Replace with an actual image path for gamification
    title: "Gamification as a Tool for Impact",
    date: "June 28, 2025",
    time: "8 min read",
    authorImage: "/images/avatars/avatar_2.jpg", // Replace with an actual author image path
    authorName: "Impactoverse Team",
    text: "At Impactoverse, we see gamification as a powerful tool for education, engagement, and action. By turning real-world challenges into interactive experiences, we are ensuring that learning is not only more interactive and accessible but also more impactful.",
    subImages: [], // Add sub-image paths if applicable
  };

  return (
    <div>
      <Meta title={`${blogPostData.title} || Impactoverse `} />

      <div className="pt-[5.5rem] lg:pt-24">

        <section className="relative py-16 md:py-24">
          <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
            <Image
              width={1519}
              height={773}
              priority
              src="/images/gradient_light.jpg"
              alt="gradient"
              className="h-full w-full object-cover"
            />
          </picture>
          {/* In a real scenario, you'd filter `single_news_data` or fetch specific data */}
          {/* For this example, we're using the hardcoded `blogPostData` */}
          <div className="container" key={blogPostData.id}>



            <figure className="mb-16">
              <Image
                width={900}
                height={400}
                priority
                src={blogPostData.image}
                alt="post image"
                className="rounded-2xl object-cover mx-auto"
              />
            </figure>


            <article className="mb-12">

              <div className="article-content">
                <div className="mx-auto mb-16">

                  <h2 className="font-display text-3xl text-jacarta-700 dark:text-white mb-8">
                    Gamification as a Tool for Impact
                  </h2>
                </div>
                <p className="text-lg leading-normal">
                  At Impactoverse, we see gamification as a powerful tool for
                  education, engagement, and action. By turning real-world
                  challenges into interactive experiences, we are ensuring that
                  learning is not only more interactive and accessible but also
                  more impactful. That’s why we are using gamification to
                  transform complex challenges into hands-on, immersive
                  experiences.
                </p>
                <p className="text-lg" >
                  For us, gamification is more than just adding points or
                  badges; it’s about creating experiences that drive real-world
                  learning and action. Whether it’s helping students explore
                  science without expensive lab kits, guiding young
                  entrepreneurs through business challenges, or inspiring people
                  to take action for ocean conservation, we are using technology
                  to bridge gaps and make learning more engaging.
                </p>
                <h2 className="text-lg">
                  Making Science Accessible—Without the Need for a Lab
                </h2>
                <p className="text-lg" >
                  For many students, access to hands-on science education is
                  limited. Lab kits, microscopes, and science equipment are
                  often out of reach, making it difficult for young learners to
                  engage with scientific concepts in a meaningful way.
                </p>
                <p className="text-lg" >
                  Through interactive experiences like the Daphnia Game with
                  University of Birmingham and Professor Luisa Orsini, we are
                  changing this. Instead of just reading about water quality,
                  students can work in a simulated lab environment, conducting
                  real scientific investigations in a digital space. This
                  approach not only makes science accessible anywhere but also
                  encourages curiosity and problem-solving, ensuring that
                  students are active participants in their learning.
                </p>
                <h2 className="text-lg">
                  Empowering Young Entrepreneurs Through Play
                </h2>
                <p className="text-lg" >
                  Entrepreneurial thinking is a critical skill for the future,
                  yet many young people don’t have access to traditional
                  business education. We are using gamification to turn
                  entrepreneurship into an interactive experience with Cathy
                  Dimarchos and Solutions2U who is sponsoring an
                  entrepreneurship programme for the St Judes School in
                  Tanzania. Learners can learn fundamental business principles,
                  and navigate real-world challenges—all within a digital
                  environment.
                </p>
                <p className="text-lg" >
                  By stepping into the role of an entrepreneur, students learn
                  by doing—making decisions, solving problems, and adapting to
                  unexpected challenges. This hands-on approach builds
                  confidence, critical thinking, and innovation skills,
                  ensuring that learning is not just theoretical but practical
                  and actionable.
                </p>
                <h2 className="text-lg">
                  Driving Conservation Efforts with Interactive Learning
                </h2>
                <p className="text-lg" >
                  The environmental challenges our planet faces can sometimes
                  feel overwhelming, but interactive experiences can make a
                  difference by turning awareness into action.
                </p>
                <p className="text-lg" >
                  Through gamification, we are helping people engage with
                  conservation efforts in a meaningful way. For example, Think
                  Ocean’s interactive experiences focused on sea turtles allow
                  players to save turtle eggs and tackle plastic pollution, and
                  through the experience develop an understanding of the threats
                  they face from pollution and climate change, taking part in
                  challenges that encourage real-world behavior change, such as
                  reducing plastic waste.
                </p>
                <p className="text-lg" >
                  By creating immersive conservation experiences, we are
                  fostering deeper connections to the natural world and
                  empowering individuals to take part in protecting it, with all
                  virtual activity linked to real world initiatives and impact.
                </p>
                <blockquote className="text-jacarta-700 !my-10 text-lg italic dark:text-white text-lg">
                  “We are using technology to bridge the gap between knowledge and
                  action- empowering people to learn, engage, and create
                  change.”
                  <cite className="text-jacarta-400 text-2xs mt-3 block not-italic tracking-tight">
                    — Impactoverse Team
                  </cite>
                </blockquote>
                <p className="text-lg" >
                  This is just the beginning. As we continue developing new
                  gamified experiences, we are committed to building a future
                  where learning is dynamic, inclusive, and inspiring. Get in
                  touch to find out more!
                </p>
              </div>
            </article>

            {/* <div className="mx-auto max-w-[48.125rem]">
              <div className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-2xl mb-16 flex border bg-white p-8">
                <Image
                  width={144}
                  height={144}
                  src={blogPostData.authorImage}
                  alt="author"
                  className="mr-4 h-16 w-16 object-cover shrink-0 self-start rounded-lg md:mr-8 md:h-[9rem] md:w-[9rem]"
                />
                <div>
                  <span className="text-jacarta-700 font-display mb-3 mt-2 block text-base dark:text-white">
                    {blogPostData.authorName}
                  </span>
                  <p className="dark:text-jacarta-300 mb-4">
                    {blogPostData.text}
                  </p>
                </div>
              </div>
            </div> */}

          </div>
        </section>

      </div>
    </div>
  );
};

export default Single_post;